// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"d94f74b8","496":"8d8889c6","647":"b284cf1f"}[chunkId] + ".chunk.js";
};